module.exports = "../fonts/information_icon.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/information_icon.svg
// module id = 435
// module chunks = 0